import { Loader2 } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { Role } from '@geoic/shared';
import { useAuth } from '@/features/auth/auth-context.js';
import { landingPath } from './navigation.js';

/**
 * Himoyalangan yo'l.
 *
 * Seans tekshiruvi tugamaguncha HECH NARSA ko'rsatilmaydi: aks holda
 * sahifa yangilanganda login ekrani bir lahza chaqnab, keyin yo'qolardi.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) return <FullPageSpinner />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  return <>{children}</>;
}

/**
 * Rol bo'yicha cheklangan yo'l.
 *
 * Menyuda band ko'rinmasa ham, manzilni qo'lda yozib kirish mumkin —
 * shuning uchun tekshiruv yo'l darajasida ham takrorlanadi. Haqiqiy
 * himoya baribir serverda (`RolesGuard`).
 */
export function RequireRole({
  roles,
  children,
}: {
  roles: readonly Role[];
  /**
   * Berilmasa `<Outlet />` chiziladi.
   *
   * Kontent bo'limlarida ro'yxat va tahrirlash yo'llari BITTA rol
   * tekshiruvi ostida turadi (B7) — har bir yo'lda `RequireRole` ni
   * takrorlash o'rniga u tashqi (layout) yo'l bo'ladi.
   */
  children?: React.ReactNode;
}) {
  const { user, ready } = useAuth();

  if (!ready) return <FullPageSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={landingPath(user.role)} replace />;

  return <>{children ?? <Outlet />}</>;
}

export function FullPageSpinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Loader2 className="size-6 animate-spin text-brand-600" aria-label="Yuklanmoqda" />
    </div>
  );
}
